import React from 'react';
import PropTypes from 'prop-types';

import CustomPageTopCarouselContentDescription from "./CustomPageTopCarouselContentDescription";

const CustomPageTopCarouselDescriptionWrapper = (props) => {

  let {
    pageBlock,
    pageTypeId,
  } = props;

  const widthClass = () => {
    return pageTypeId === '5' ? 'm_contentWrap' : '';
  };
  
  return (
    <div className={widthClass()} id={"page_block_" + pageBlock.pageBlockId}>
      <CustomPageTopCarouselContentDescription pageBlock={pageBlock} pageTypeId={pageTypeId}/>
    </div>
  );
};

CustomPageTopCarouselDescriptionWrapper.propTypes = {
  pageBlock: PropTypes.shape({
    pageBlockId: PropTypes.number,
    pageBlockTypeCode: PropTypes.string,
    pageBlockTitle: PropTypes.string,
    pageBlockDescriptionHtml: PropTypes.string,
    pageBlockLayoutTypek: PropTypes.shape( {
      pageBlockLayoutTypeCode: PropTypes.string,
      pageBlockItemsPerLinePcViewCount: PropTypes.number,
      pageBlockItemsPerLineSpViewCount: PropTypes.number,
    }),
  }).isRequired,
  pageTypeId: PropTypes.string.isRequired,
};

export default CustomPageTopCarouselDescriptionWrapper;
